import { makeStyles } from '@material-ui/core';

export const useStyledTextFieldStyles = makeStyles({
  field: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#F8F9FA',
      minHeight: 40,

      '& fieldset': {
        borderColor: '#AFBAC6'
      },
      '&:hover fieldset': {
        borderColor: '#AFBAC6'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#AFBAC6'
      }
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#5D7083',
      opacity: 1
    }
  },
  textarea: {
    '& .MuiOutlinedInput-root': {
      backgroundColor: '#fff',
      minHeight: 40,
      borderRadius: 12,

      '& fieldset': {
        borderColor: '#AFBAC6'
      },
      '&:hover fieldset': {
        borderColor: '#AFBAC6'
      },
      '&.Mui-focused fieldset': {
        borderColor: '#AFBAC6'
      }
    },
    '& .MuiInputBase-input::placeholder': {
      color: '#5D7083',
      opacity: 1
    }
  }
});
